module.exports = __webpack_public_path__ + "img/magnifiyng-glass.a590aab6.svg";